module.exports = __webpack_public_path__ + "img/30.0401b3a8.png";